module.exports = __webpack_public_path__ + "img/Paso 4.19f1dc4c.png";